import React from 'react';
import { FormTitleWrapper } from 'page/Application/ManageNotificationList/component/Form/FormTitle/styled';

const FormTitle = ({ title, styles }) => {
  return <FormTitleWrapper style={styles}>{title}</FormTitleWrapper>;
};

export default FormTitle;
